import './globals';
import { MultiSelect, MultiSelectPlaceholderTypeEnum } from '@erkenes/multiselect';
import PageLoadedQueue from './PageLoadedQueue';
import { MultiSelectOptionI } from '@erkenes/multiselect/dist/MultiSelectOption';

/**
 * Initialize Select fields
 */
(function (document, PageLoadedQueue) {
    PageLoadedQueue.addFunction(function () {
        /** @var NodeListOf<HTMLSelectElement> */
        const selectFields = document.querySelectorAll('select');
        selectFields.forEach((select) => {
            const multiselect = new MultiSelect(select, {
                closeListOnItemSelect: !select.multiple,
                showApplyButton: true,
                search: select.options.length > 6 || select.multiple,
                placeholder: select.dataset.msPlaceholder ?? select.dataset.placeholder ?? select.ariaLabel ?? select.title ?? select.dataset.title ?? 'Auswählen',
                placeholderType: MultiSelectPlaceholderTypeEnum.default,
                showCheckbox: select.multiple,
                translations: {
                    selectAll: 'Alles auswählen',
                    searchPlaceholder: 'Suche...',
                    selected: '%i ausgewählt',
                    applyButton: 'Übernehmen',
                },
                applyButton: {
                    classList: 'btn btn-primary w-100',
                },
            });
            console.groupEnd();
        });
    });
})(document, PageLoadedQueue);
